import { OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { fromEvent, merge, Subject } from 'rxjs';
import { filter, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { NotificationsApi } from '../../core/api/notifications.api';
import { SocketService } from '../../core/services/socket.service';
var VerticalLayoutComponent = /** @class */ (function () {
    function VerticalLayoutComponent(fuseConfigService, authenticationService, notificationsApi, socketService) {
        this.fuseConfigService = fuseConfigService;
        this.authenticationService = authenticationService;
        this.notificationsApi = notificationsApi;
        this.socketService = socketService;
        this.unsubscribeAll$ = new Subject();
        this.unreadNotificationsCount = 0;
        this.subscriptions = new Subject();
        this.sidebarOpen = true;
    }
    VerticalLayoutComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.fuseConfigService.config
            .pipe(takeUntil(this.unsubscribeAll$))
            .subscribe(function (config) {
            _this.fuseConfig = config;
        });
        merge(fromEvent(window, 'refresh-notification-count'), this.socketService.realtimeNotification$).pipe(startWith({}), takeUntil(this.subscriptions), filter(function () { return !!_this.authenticationService.accessToken; }), switchMap(function () { return _this.notificationsApi.getNotificationsUnreadCount(); })).subscribe(function (count) {
            _this.unreadNotificationsCount = count;
        });
    };
    VerticalLayoutComponent.prototype.ngOnDestroy = function () {
        this.unsubscribeAll$.next();
        this.unsubscribeAll$.complete();
    };
    Object.defineProperty(VerticalLayoutComponent.prototype, "account", {
        get: function () {
            return this.authenticationService.user && this.authenticationService.user.account;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLayoutComponent.prototype, "permissions", {
        get: function () {
            return this.authenticationService.permissions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLayoutComponent.prototype, "environment", {
        get: function () {
            return environment;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLayoutComponent.prototype, "language", {
        get: function () {
            return window.navigator.language;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLayoutComponent.prototype, "user", {
        get: function () {
            return this.authenticationService.user;
        },
        enumerable: true,
        configurable: true
    });
    VerticalLayoutComponent.prototype.toggleSidebar = function ($event) {
        this.sidebarOpen = !$event.detail;
    };
    return VerticalLayoutComponent;
}());
export { VerticalLayoutComponent };
